import { actions } from 'actions/datepickerRange.js';

const initialState = [];

export default function datepickerReducer(state = initialState, action) {
  if (action.type === actions.RANGE) {
    return action.datepickerRange;
  } else if (action.type === actions.OPEN) {
    return true;
  }
  return state;
}
